import { render, staticRenderFns } from "./AddEditBranchModal.vue?vue&type=template&id=71d247c4&"
import script from "./AddEditBranchModal.vue?vue&type=script&lang=js&"
export * from "./AddEditBranchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports